const getObjectDiffs = (object, base) => {
  const changes = (object, base) => {
    return _.transform(object, function(result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}

const decodeJSON = (json) => {

  const tempDiv = document.createElement("div");

  const decodeEntities = (str) => {
    tempDiv.innerHTML = str;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const deepDecode = (obj) => {
    if (typeof obj === "string") {
      return decodeEntities(obj);
    } else if (Array.isArray(obj)) {
      return obj.map(deepDecode);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, deepDecode(value)]));
    }
    return obj;
  };

  return deepDecode(json);
};



export {
    getObjectDiffs,
    decodeJSON
}